import { useEffect } from 'react'
import { FormControl, FormLabel, Switch } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import ScoreOptionsForm from './components/ScoreOptionsForm'

type Props = {
  formMethods: UseFormReturn<CustomFormQuestion>
  kind?: string
}

export default function ScoreOptions({ formMethods, kind }: Props) {
  const { watch, setValue, register } = formMethods

  const options: string[] = watch('options') || []
  const hasScore: boolean = watch('has_score') || false

  const showScoreOptionsForm = hasScore && options.length > 0

  useEffect(() => {
    if (hasScore) {
      const newScoreSettings = options.map((option, index) => {
        const scoreOption = watch(`score_${index}`)
        return { key: option, value: Number(scoreOption) || 0 }
      })

      setValue('score_settings', { options: newScoreSettings })
    }
  }, [hasScore, options])

  useEffect(() => {
    if (!hasScore) setValue('score_settings', null)
  }, [hasScore])

  useEffect(() => {
    if (kind !== 'SINGLE_SELECTION_BOX' && kind !== 'MULTIPLE_SELECTION_BOX' && kind !== 'SINGLE_SELECTION_LIST') {
      setValue('has_score', false)
      setValue('options', [])
      setValue('score_settings', null)
    }
  }, [kind])

  return (
    <>
      <FormControl display="flex" flexDir="column" gap={2}>
        <FormLabel fontWeight="bold">As opções possuem pontuação</FormLabel>
        <Switch maxWidth="max-content" isChecked={hasScore} {...register('has_score')} />
      </FormControl>

      {showScoreOptionsForm && <ScoreOptionsForm options={options} formMethods={formMethods} />}
    </>
  )
}
